const CheckoutTypes = require("action-types/checkout");
const WebClient = require("utils/web-client");
const GTMCustom = require("../utils/gtm-custom");

const actions = exports;

// TODO Doesn't _appear_ that we ever use the redux-stored payment option ID? Seems used only in component state e.g. transactionDialog, checkoutForm
exports.selectPaymentOption = paymentOptionId => {
    return (dispatch, getState) => {
        dispatch({
            type: CheckoutTypes.SELECT_PAYMENT_OPTION,
            payload: { paymentOptionId }
        });

        const { auth, checkout } = getState();
        const paymentOpt = checkout.paymentOptions.find(
            opt => opt.id === paymentOptionId
        );
        GTMCustom.checkout(paymentOpt, auth.credentials.user.id);
    };
};

exports.selectDownloadPackage = downloadPackageId => {
    return (dispatch, getState) => {
        dispatch({
            type: CheckoutTypes.SELECT_DOWNLOAD_PACKAGE,
            payload: { downloadPackageId }
        });
    };
};

exports.loadPaymentOptionsBegin = () => {
    return {
        type: CheckoutTypes.LOAD_PAYMENT_OPTIONS_BEGIN
    };
};

exports.loadPaymentOptionsSuccess = paymentOptions => {
    return {
        type: CheckoutTypes.LOAD_PAYMENT_OPTIONS_SUCCESS,
        payload: { paymentOptions }
    };
};

exports.loadPaymentOptionsFail = error => {
    return {
        type: CheckoutTypes.LOAD_PAYMENT_OPTIONS_FAIL,
        payload: { error }
    };
};

exports.fetchPurchaseOptions = () => {
    return dispatch => {
        dispatch(actions.loadPaymentOptionsBegin());

        const getPaymentOptions = WebClient.get("/payment-options");

        getPaymentOptions
            .then(({ data }) => {
                dispatch(actions.loadPaymentOptionsSuccess(data));
            })
            .catch(error => {
                dispatch(actions.loadPaymentOptionsFail(error));
            });

        return getPaymentOptions;
    };
};

exports.loadDownloadPackagesBegin = () => {
    return {
        type: CheckoutTypes.LOAD_DOWNLOAD_PACKAGES_BEGIN
    };
};

exports.loadDownloadPackagesSuccess = downloadPackages => {
    return {
        type: CheckoutTypes.LOAD_DOWNLOAD_PACKAGES_SUCCESS,
        payload: { downloadPackages }
    };
};

exports.loadDownloadPackagesFail = error => {
    return {
        type: CheckoutTypes.LOAD_DOWNLOAD_PACKAGES_FAIL,
        payload: { error }
    };
};

exports.fetchDownloadPackages = () => {
    return dispatch => {
        dispatch(actions.loadDownloadPackagesBegin());

        const getDownloadPackages = WebClient.get("/download-packages");

        getDownloadPackages
            .then(({ data }) => {
                dispatch(actions.loadDownloadPackagesSuccess(data));
            })
            .catch(error => {
                dispatch(actions.loadDownloadPackagesFail(error));
            });

        return getDownloadPackages;
    };
};

exports.purchaseOptionBegin = () => {
    return {
        type: CheckoutTypes.PURCHASE_OPTION_BEGIN
    };
};

exports.purchaseOptionSuccess = payment => {
    return {
        type: CheckoutTypes.PURCHASE_OPTION_SUCCESS,
        payload: { payment }
    };
};

exports.purchaseOptionFail = error => {
    return {
        type: CheckoutTypes.PURCHASE_OPTION_FAIL,
        payload: { error }
    };
};

exports.purchaseOption = (token, paymentOptionId, promoCode = null) => {
    return (dispatch, getState) => {
        dispatch(actions.purchaseOptionBegin());

        const payload = {
            stripeToken: token.id,
            paymentOptionId
        };

        if (promoCode) {
            payload.promoCode = promoCode;
        }

        const postPayment = WebClient.post("/user/credits", payload);

        postPayment
            .then(({ data }) => {
                dispatch(actions.purchaseOptionSuccess(data));

                const { auth, checkout } = getState();
                const paymentOpt = checkout.paymentOptions.find(
                    opt => opt.id === paymentOptionId
                );
                GTMCustom.purchase(paymentOpt, auth.credentials.user.id);
            })
            .catch(error => {
                dispatch(actions.purchaseOptionFail(error));
            });

        return postPayment;
    };
};

exports.selectDownloadPackage = downloadPackageId => {
    return {
        type: CheckoutTypes.SELECT_DOWNLOAD_PACKAGE,
        payload: { downloadPackageId }
    };
};

// modelId will be undefined for credits-only transactions
exports.startTransaction = (transactionType, modelId) => {
    return {
        type: CheckoutTypes.START_TRANSACTION,
        payload: {
            id: modelId,
            type: transactionType
        }
    };
};

exports.endTransaction = () => {
    return {
        type: CheckoutTypes.END_TRANSACTION
    };
};



// WEBPACK FOOTER //
// ./src/actions/checkout.js